<div class="container-step">
    <ul class="progress-bar">
        @for (stepper of steps(); track $index) {
        <ng-container>
            <li [ngClass]="stepper.state"
                class="text-step {{ stepper.isCurrenPosition ? 'font-poppins-bold' : 'font-poppins-regular' }} {{steps().length < 4 ? 'w-1/3' : 'w-1/4'}}">
                <div class="text">{{ stepper.label | translate }}</div>
            </li>
        </ng-container>
        }
    </ul>
</div>